var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBlueLg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6875 28.025V1.21252",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6875 1.21252H6.3125V28.025",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 36.1081L51.3125 23.7125V55.5875H0.6875V23.7125L16.7262 36.1869",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 52.775L26 34.9625L51.3125 52.775",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6782 19.1225L51.3126 23.7125",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 23.7125L6.3125 19.13",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3225 16.175C35.3563 16.4956 35.3732 16.82 35.3732 17.15C35.3732 22.3288 31.175 26.525 25.9982 26.525C20.8213 26.525 16.6232 22.3288 16.6232 17.15C16.6232 11.9731 20.8213 7.77502 25.9982 7.77502C27.7232 7.77502 29.3375 8.2419 30.7269 9.05377",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9812 10.5519L25.9981 19.535L21.6687 15.2094",
    stroke: "#455A64",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6875 28.025V1.21252",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6875 1.21252H6.3125V28.025",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 36.1081L51.3125 23.7125V55.5875H0.6875V23.7125L16.7262 36.1869",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 52.775L26 34.9625L51.3125 52.775",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6782 19.1225L51.3126 23.7125",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 23.7125L6.3125 19.13",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3225 16.175C35.3563 16.4956 35.3732 16.82 35.3732 17.15C35.3732 22.3288 31.175 26.525 25.9982 26.525C20.8213 26.525 16.6232 22.3288 16.6232 17.15C16.6232 11.9731 20.8213 7.77502 25.9982 7.77502C27.7232 7.77502 29.3375 8.2419 30.7269 9.05377",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9812 10.5519L25.9981 19.535L21.6687 15.2094",
    stroke: "#2191F0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlueLg);
export default __webpack_public_path__ + "static/media/email-blue-lg.e855f45a159f1e99bc5dbcffd4f1c2aa.svg";
export { ForwardRef as ReactComponent };